<template>
  <div class="launch-page ultimate-theme" @scroll.passive="onScroll">
    <HeaderMain />

    <main class="launch-page__main" ref="mainContainer">
      
      <!-- 1. MEGA HERO (SCROLL REACTIVE) -->
      <section class="mega-hero">
        <div class="mega-hero__glow"></div>
        <div class="mega-hero__content container" :style="{ transform: `scale(${heroScale})`, opacity: heroOpacity }">
          <div class="mega-hero__badge">
            <span class="badge-dot"></span> THE FOMO ENGINE
          </div>
          
          <h1 class="mega-hero__title">
            <span class="slide-left" :style="{ transform: `translateX(${scrolled * -0.5}px)` }">NO VENDEMOS</span>
            <span class="slide-right" :style="{ transform: `translateX(${scrolled * 0.5}px)` }">TICKETS.</span>
            <span class="slide-center">CREAMOS SOLD OUTS.</span>
          </h1>
          
          <p class="mega-hero__subtitle">
            La infraestructura operativa definitiva para eventos de alto volumen. 
            Ticketing de conversión brutal, red de promotores rastreable y control de acceso inquebrantable.
          </p>
          
          <div class="mega-hero__actions">
            <button class="btn-mega" @click="goToCreate">
              Lanzar mi evento <i class="fas fa-arrow-right"></i>
            </button>
            <button class="btn-mega-ghost" @click="goToLogin">
              Ya soy organizador
            </button>
          </div>
        </div>
      </section>

      <!-- 2. SCROLLYTELLING: TEXT REVEALS FROM SIDES -->
      <section class="st-reveal-section">
        <div class="st-reveal-container container">
          <div class="st-block" v-intersect="onIntersect">
            <div class="st-text st-text--left">
              <span class="st-num">01.</span>
              <h2>Conversión sin fricción.</h2>
              <p>Un checkout limpio en 2 pasos que no rompe el deseo de compra. Sin registros obligatorios, sin captchas infinitos. Tu público quiere entrar, nosotros los dejamos pasar.</p>
            </div>
          </div>
          <div class="st-block" v-intersect="onIntersect">
            <div class="st-text st-text--right">
              <span class="st-num">02.</span>
              <h2>Red de ventas en vivo.</h2>
              <p>Asigna links únicos a tus promotores, RRPP y embajadores. Rastrea quién te trae gente en tiempo real y liquida comisiones con precisión matemática desde tu dashboard.</p>
            </div>
          </div>
          <div class="st-block" v-intersect="onIntersect">
            <div class="st-text st-text--left">
              <span class="st-num">03.</span>
              <h2>La puerta está blindada.</h2>
              <p>Escáner de hiper-velocidad que no colapsa sin conexión. Escanea, valida y revisa estadisticas de acceso sin hardware a medida. Solo usa la app y domina la noche.</p>
            </div>
          </div>
        </div>
      </section>

      <!-- 3. HORIZONTAL SCROLL: LA VITRINA (EVENT CARDS SLIDING) -->
      <section class="horizontal-wrap" ref="horizontalWrap">
        <div class="sticky-box">
          <div class="h-scroll-header container">
             <h2 class="h-title">La vitrina definitiva.</h2>
             <p class="h-subtitle">La mejor plataforma es la que luce tus eventos, no la que se luce a sí misma. 100% enfocada en tu marca y en que factures más.</p>
          </div>
          
          <div class="scroll-track-container">
            <div class="scroll-track" :style="{ transform: `translateX(-${hScrollProgress}%)` }">
               
               <!-- Card 1 -->
               <div class="h-card">
                 <div class="h-card-visual ticket-ui">
                   <div class="ui-ticket">
                     <i class="fas fa-ticket-alt"></i>
                     <strong>Fase 1: Early Bird</strong>
                     <span class="ui-price">$30 USD</span>
                     <div class="ui-bar"><div class="ui-fill" style="width: 85%;"></div></div>
                     <small>Agotándose</small>
                   </div>
                 </div>
                 <div class="h-card-text">
                   <h3>Etapas Automáticas</h3>
                   <p>Sube el precio sin tocar código. Define aforo y precio, el sistema hace el resto.</p>
                 </div>
               </div>

               <!-- Card 2 -->
               <div class="h-card">
                 <div class="h-card-visual promo-ui">
                   <div class="ui-promo">
                     <span class="tag"><i class="fas fa-tag"></i> FOMO50</span>
                     <div class="promo-stats">
                       <strong>50% OFF</strong>
                       <small>14/20 usados</small>
                     </div>
                   </div>
                   <div class="ui-promo hidden-code">
                     <i class="fas fa-lock"></i> Código Oculto
                   </div>
                 </div>
                 <div class="h-card-text">
                   <h3>Códigos Dinámicos</h3>
                   <p>Descuentos por porcentaje, monto fijo o códigos de acceso oculto para listas VIP exclusivas.</p>
                 </div>
               </div>

               <!-- Card 3 -->
               <div class="h-card">
                 <div class="h-card-visual stats-ui">
                   <div class="ui-chart">
                     <div class="bar-col" style="height: 30%;"></div>
                     <div class="bar-col" style="height: 60%;"></div>
                     <div class="bar-col" style="height: 100%;"></div>
                     <div class="bar-col highlight" style="height: 80%;"></div>
                   </div>
                   <div class="ui-stat-num">+$14,200 <i class="fas fa-arrow-up"></i></div>
                 </div>
                 <div class="h-card-text">
                   <h3>Control Financiero</h3>
                   <p>Desembolsos rápidos directos a tu cuenta. Mantén la fluidez de caja para tu producción.</p>
                 </div>
               </div>

               <!-- Card 4 -->
               <div class="h-card">
                 <div class="h-card-visual door-ui">
                   <div class="ui-scanner">
                     <i class="fas fa-qrcode"></i>
                     <div class="scan-beam"></div>
                   </div>
                   <div class="ui-result">Aprobado</div>
                 </div>
                 <div class="h-card-text">
                   <h3>App de Escáner Invicto</h3>
                   <p>Control de aforo real. Sin dobles entradas. Tu operación en la puerta fluye sin problemas.</p>
                 </div>
               </div>

            </div>
          </div>
        </div>
      </section>

      <!-- 4. TRANSPARENT PRICING -->
      <section class="mega-pricing">
        <div class="container pricing-grid">
          <div class="pricing-content">
            <h2>Modelo transparente.<br/>Cero asteriscos.</h2>
            <p>Usar FOMO es completamente gratis. Solo cobramos <strong>$1 USD + fee de pasarela</strong> por cada ticket vendido de manera exitosa.</p>
            <ul class="pricing-list">
              <li><i class="fas fa-check"></i> El fee se puede trasladar íntegramente al comprador final.</li>
              <li><i class="fas fa-check"></i> Eventos o tickets gratuitos = $0 USD.</li>
              <li><i class="fas fa-check"></i> Sin contratos, mensualidades o mantenimiento.</li>
            </ul>
          </div>
          <div class="pricing-card-wrapper" v-intersect="onIntersect">
            <div class="pricing-glass-card">
              <span class="currency">$</span>
              <span class="amount">1</span>
              <span class="period">USD</span>
              <p class="fee-text">+ Fee de procesador de pago</p>
              <button class="btn-mega full-width" @click="goToCreate">Empezar a vender</button>
            </div>
          </div>
        </div>
      </section>

      <!-- 5. FINAL PUSH CTA -->
      <section class="mega-cta">
        <div class="mega-cta-bg"></div>
        <div class="container cta-content-box" v-intersect="onIntersect">
          <h2 class="megatext-reveal">Tu Sold Out empieza hoy.</h2>
          <button class="btn-mega" @click="goToCreate">Abrir mi workspace ahora</button>
        </div>
      </section>
      
    </main>

    <FooterMain />
  </div>
</template>

<script>
import FooterMain from '@/components/FooterMain.vue'
import HeaderMain from '@/components/HeaderMain.vue'

export default {
  name: 'LaunchEventView',
  components: {
    HeaderMain,
    FooterMain,
  },
  data() {
    return {
      scrolled: 0,
      heroScale: 1,
      heroOpacity: 1,
      hScrollProgress: 0,
    }
  },
  directives: {
    intersect: {
      mounted(el) {
        const observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add('is-visible');
          }
        }, { threshold: 0.2 });
        observer.observe(el);
        el.$__observer = observer;
      },
      unmounted(el) {
        if (el.$__observer) {
          el.$__observer.disconnect();
        }
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.handleScroll(); // init
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollY = window.scrollY;
      this.scrolled = scrollY;
      
      // Hero Scale & Fade
      this.heroScale = 1 + scrollY * 0.0005;
      this.heroOpacity = Math.max(0, 1 - scrollY * 0.0015);

      // Horizontal Wrap Math
      if (this.$refs.horizontalWrap) {
        const wrapRect = this.$refs.horizontalWrap.getBoundingClientRect();
        // The total scrollable distance inside the wrapper is (height - viewportHeight)
        const maxScroll = wrapRect.height - window.innerHeight;
        
        if (wrapRect.top <= 0 && wrapRect.bottom >= window.innerHeight) {
          // Inside the scroll area
          let progress = -wrapRect.top / maxScroll;
          // Calculate track width translate %
          // If we have 4 cards, max translation is roughly 60-70% depending on card width.
          // Let's translate from 0 to 65% based on progress
          this.hScrollProgress = Math.max(0, Math.min(65, progress * 65));
        } else if (wrapRect.top > 0) {
          this.hScrollProgress = 0;
        } else {
          this.hScrollProgress = 65;
        }
      }
    },
    goToCreate() {
      this.$router.push({ name: 'event-creation' });
    },
    goToLogin() {
      this.$router.push({ name: 'preloader', query: { next: '/events' } });
    }
  }
}
</script>

<style scoped>
/* ==========================================================================
   ULTIMATE THEME (APPLE / STRIPE / VERCEL GOD TIER)
   ========================================================================== */
.ultimate-theme {
  --bg-dark: #000000;
  --bg-panel: #0a0a0c;
  --bg-panel-2: #141416;
  --border-line: #1f1f22;
  --text-pure: #ffffff;
  --text-faint: #88888e;
  --brand-purple: #7000ff;
  --brand-purple-dim: rgba(112, 0, 255, 0.4);
  
  background-color: var(--bg-dark);
  color: var(--text-pure);
  font-family: 'Space Grotesk', -apple-system, sans-serif;
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
}
@media(max-width: 768px) { .container { padding: 0 20px; } }

/* ==========================================================================
   BUTTONS (SERIOUS B2B VIP)
   ========================================================================== */
.btn-mega {
  background: #ffffff;
  color: #000000;
  padding: 16px 36px;
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  display: inline-flex;
  align-items: center;
  gap: 12px;
}
.btn-mega:hover {
  transform: scale(1.02);
  box-shadow: 0 0 40px rgba(255,255,255,0.1);
}

.btn-mega-ghost {
  background: transparent;
  color: #fff;
  padding: 16px 36px;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.2);
  cursor: pointer;
  transition: all 0.3s ease;
}
.btn-mega-ghost:hover {
  background: rgba(255,255,255,0.05);
  border-color: #fff;
}
.full-width { width: 100%; justify-content: center; }

/* ==========================================================================
   1. MEGA HERO
   ========================================================================== */
.mega-hero {
  height: 100vh;
  min-height: 800px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
  overflow: hidden;
}

.mega-hero__glow {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 60vw; height: 60vw;
  background: radial-gradient(circle, var(--brand-purple-dim) 0%, transparent 60%);
  opacity: 0.5;
  filter: blur(100px);
  z-index: 0;
  pointer-events: none;
}

.mega-hero__content {
  position: relative;
  z-index: 10;
  will-change: transform, opacity;
}

.mega-hero__badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.1);
  padding: 8px 16px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  color: var(--text-faint);
  margin-bottom: 30px;
}
.badge-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--brand-purple); }

.mega-hero__title {
  font-size: clamp(3.5rem, 8vw, 8rem);
  font-weight: 900;
  line-height: 0.9;
  letter-spacing: -0.04em;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
}
.mega-hero__title span { display: block; will-change: transform; }

.slide-left { 
  color: transparent; 
  -webkit-text-stroke: 1px rgba(255,255,255,0.3);
  align-self: flex-start;
}
.slide-right {
  color: var(--brand-purple);
  align-self: flex-end;
}
.slide-center {
  color: #fff;
  align-self: center;
}

.mega-hero__subtitle {
  font-size: clamp(1.1rem, 2vw, 1.5rem);
  color: var(--text-faint);
  max-width: 700px;
  margin: 0 auto 40px;
  line-height: 1.5;
  font-weight: 400;
}

.mega-hero__actions {
  display: flex;
  gap: 20px;
  justify-content: center;
}
@media(max-width: 600px) {
  .mega-hero__actions { flex-direction: column; }
}

/* ==========================================================================
   2. SCROLLYTELLING TEXT REVEALS (L & R)
   ========================================================================== */
.st-reveal-section {
  padding: 150px 0;
  background: var(--bg-dark);
}

.st-block {
  min-height: 70vh;
  display: flex;
  align-items: center;
}

.st-text {
  max-width: 600px;
  opacity: 0;
  transition: all 1s cubic-bezier(0.16, 1, 0.3, 1);
}

.st-text--left { transform: translateX(-100px); margin-right: auto; }
.st-text--right { transform: translateX(100px); margin-left: auto; text-align: right; }

/* In-View Class */
.st-block.is-visible .st-text {
  opacity: 1;
  transform: translateX(0);
}

.st-num {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--brand-purple);
  display: block;
  margin-bottom: 16px;
}

.st-text h2 {
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 800;
  line-height: 1;
  margin-bottom: 24px;
  letter-spacing: -0.03em;
}

.st-text p {
  font-size: 1.25rem;
  color: var(--text-faint);
  line-height: 1.6;
}

/* ==========================================================================
   3. HORIZONTAL SCROLL ENGINES
   ========================================================================== */
.horizontal-wrap {
  position: relative;
  height: 400vh; /* creates the massive scroll timeline */
  background: var(--bg-panel);
}

.sticky-box {
  position: sticky;
  top: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

.h-scroll-header {
  margin-bottom: 60px;
  z-index: 10;
}
.h-title {
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 800;
  letter-spacing: -0.03em;
  margin-bottom: 16px;
}
.h-subtitle {
  font-size: 1.25rem;
  color: var(--text-faint);
  max-width: 600px;
}

.scroll-track-container {
  width: 100%;
  overflow: hidden;
}

.scroll-track {
  display: flex;
  gap: 40px;
  padding: 0 40px;
  width: max-content;
  will-change: transform;
}

.h-card {
  width: 450px;
  background: var(--bg-panel-2);
  border: 1px solid var(--border-line);
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
@media(max-width: 768px) { .h-card { width: 320px; } }

.h-card-visual {
  height: 250px;
  background: #000;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid var(--border-line);
}

.h-card-text {
  padding: 40px 30px;
}
.h-card-text h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 16px;
}
.h-card-text p {
  color: var(--text-faint);
  font-size: 1.05rem;
  line-height: 1.5;
}

/* Abstract UIs inside H-Cards */
.ui-ticket {
  background: #111;
  border: 1px solid #333;
  padding: 20px;
  border-radius: 12px;
  width: 80%;
  text-align: left;
}
.ui-ticket i { color: var(--brand-purple); font-size: 1.5rem; margin-bottom: 10px; display: block;}
.ui-ticket strong { display: block; font-size: 1.2rem; }
.ui-price { color: var(--text-faint); display: block; margin: 8px 0; }
.ui-bar { height: 6px; background: #222; border-radius: 3px; }
.ui-fill { height: 100%; background: var(--brand-purple); }

.promo-ui { flex-direction: column; gap: 16px; }
.ui-promo {
  background: #111; border: 1px dashed #333; padding: 16px; width: 80%; border-radius: 8px;
  display: flex; justify-content: space-between; align-items: center;
}
.ui-promo .tag { background: rgba(112,0,255,0.2); color: #fff; padding: 4px 8px; border-radius: 4px;}
.promo-stats strong { font-size: 1.2rem; display: block;}
.promo-stats small { color: #555; }
.hidden-code { opacity: 0.5; border-style: solid; text-align: center; justify-content: center; gap: 8px;}

.stats-ui { flex-direction: column; }
.ui-chart { display: flex; align-items: flex-end; gap: 8px; height: 100px; margin-bottom: 20px;}
.bar-col { width: 30px; background: #333; border-radius: 4px 4px 0 0; }
.bar-col.highlight { background: var(--brand-purple); }
.ui-stat-num { font-size: 2rem; font-weight: 800; color: #fff; }

.door-ui { flex-direction: column; gap: 20px;}
.ui-scanner { width: 100px; height: 100px; border: 2px solid #333; border-radius: 20px; position:relative; display:flex; align-items:center; justify-content:center; font-size: 2.5rem; color:#fff;}
.scan-beam { position:absolute; top:0; left:0; right:0; height:2px; background: #27c93f; box-shadow: 0 0 10px #27c93f; animation: scan 2s infinite ease-in-out; }
.ui-result { color: #27c93f; font-weight: 700; font-size: 1.2rem; background: rgba(39,201,63,0.1); padding: 8px 24px; border-radius: 999px;}

@keyframes scan { 0% { top: 0; } 50% { top: 100%; } 100% { top: 0; } }

/* ==========================================================================
   4. TRANSPARENT PRICING
   ========================================================================== */
.mega-pricing {
  padding: 150px 0;
  background: var(--bg-dark);
}
.pricing-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 100px;
  align-items: center;
}
@media(max-width: 900px) { .pricing-grid { grid-template-columns: 1fr; gap: 60px; } }

.pricing-content h2 {
  font-size: clamp(3rem, 5vw, 4rem);
  font-weight: 900;
  letter-spacing: -0.04em;
  margin-bottom: 24px;
  line-height: 1;
}
.pricing-content p {
  font-size: 1.2rem;
  color: var(--text-faint);
  margin-bottom: 40px;
  line-height: 1.6;
}
.pricing-list { list-style: none; padding: 0; margin: 0; }
.pricing-list li {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  font-size: 1.1rem;
  margin-bottom: 20px;
  color: #fff;
}
.pricing-list i { color: var(--brand-purple); margin-top: 4px;}

.pricing-card-wrapper {
  opacity: 0;
  transform: translateY(100px) scale(0.9);
  transition: all 1s cubic-bezier(0.16, 1, 0.3, 1);
}
.pricing-card-wrapper.is-visible {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.pricing-glass-card {
  background: var(--bg-panel);
  border: 1px solid var(--border-line);
  padding: 80px 40px;
  border-radius: 24px;
  text-align: center;
  position: relative;
}
.pricing-glass-card::before {
  content: ''; position: absolute; top: -1px; left: 10%; right: 10%; height: 1px;
  background: linear-gradient(to right, transparent, var(--brand-purple), transparent);
}

.amount { font-size: 8rem; font-weight: 900; line-height: 0.8; letter-spacing: -0.05em; }
.currency { font-size: 3rem; font-weight: 700; color: var(--text-faint); vertical-align: top; }
.period { font-size: 2rem; color: var(--text-faint); font-weight: 600;}
.fee-text { color: var(--text-faint); font-size: 1rem; margin: 30px 0 40px; }

/* ==========================================================================
   5. FINAL PUSH
   ========================================================================== */
.mega-cta {
  padding: 200px 0;
  text-align: center;
  position: relative;
  background: var(--bg-dark);
}
.mega-cta-bg {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 80vw; height: 80vw;
  background: radial-gradient(circle, var(--brand-purple-dim) 0%, transparent 50%);
  filter: blur(120px);
  z-index: 0;
}
.cta-content-box {
  position: relative;
  z-index: 10;
  opacity: 0;
  transform: translateY(50px);
  transition: all 1.2s cubic-bezier(0.16, 1, 0.3, 1);
}
.cta-content-box.is-visible {
  opacity: 1;
  transform: translateY(0);
}
.megatext-reveal {
  font-size: clamp(3.5rem, 8vw, 6rem);
  font-weight: 900;
  letter-spacing: -0.04em;
  margin-bottom: 50px;
  line-height: 1;
}

</style>
